import { CommonEnums } from '../../common.enums';
import { AttributesUtil } from 'src/app/shared/grids/attributes/attributes.util';

export class Attribute {
    attr_Id: number;
    obj_Id: number;
    attrNm: string;

    attrPrec: number;
    attrScale: number;
    attrDTyp_Id: number;
    attrType_Cd: string;

    /** values: 0, 1 */
    notNullFlag: number;

    distKeyFlag: number;
    attrKeyTyp_Id: number;
    attrExprVal: string;
    lnk_Attr_Id: number;
    parent_Attr_Id: number;

    orgKeyFlag: number;
    upiFlag: number;
    usiFlag: number;
    nupiFlag: number;
    nusiFlag: number;

    valid_Cd: string;
    srt_Order: number;
    orderBy: number;

    clevel: number;
    occurs: number;
    redefines: number;

    /** values: N, Y */
    signed: string;

    /** values: N, Y */
    tsigned: string;

    /** values: N, Y */
    isigned: string;

    /** values: N, Y */
    rdeci: string;
    colformat: string;
    lnk_Obj_Id: number;
    dependingOn: number;
    fldFormatValue: string;
    minOccurs: number;
    dxMp_Id: number;
    isEditable: string;
    fldValue: string;

    /** values: N, Y */
    explodeFlag: string;

    /** values: N, Y */
    repeatedFlag: string;

    /** values: N, Y */
    cdcFlag: string;

    /** values: N, Y */
    timestampSpec: string;

    /** values: N, Y */
    metricsSpec: string;
    metricsType: string;
    hiddenFlg: string;

    /** values: 0, 1 */
    identityFlag: number;
    category: string;

    ref_Id: number;
    ref_Obj_Id: number;
    ref_parent_Attr_Id: number;
    ref_Cd: string;
    attrDTypNm: string;
    showAttrPrec: boolean;
    showAttrScale: boolean;
    maxAttrPrec: number;
    maxAttrScale: number;
    attrKeyTypLabel: string;
    hideAttrDTyp_Id: boolean;
    hideNotNullFlag: boolean;
    hideAttrKeyTyp_Id: boolean;
    hideDistKeyFlag: boolean;
    hideOrderBy: boolean;
    hideOccurs: boolean;
    hideRedefines: boolean;
    hideMinOcuurs: boolean;
    hideDependingOn: boolean;
    hideSigned: boolean;
    hideTsigned: boolean;
    hideIsigned: boolean;
    hideRdeci: boolean;
    error_Msg: string;
    hideRepeatedFlag: boolean;
    minAttrPrec: number;
    minAttrScale: number;
    showExplodeFlg: boolean;
    srcColNm: string;
    srcDTypNm: string;
    description: string;
    hideFldFormatValue: boolean;
    partitionflag: number;
    /** values: 0, 1 */
    clusterFlag: number;
    sortBy: number;
    sortType: string;
    showUnderline: boolean;
    dist_FieldSize: number;
    dist_FieldOffset: number;
    /** values: 0, 1 */
    saved_Column: number;
    report_Perspective: string;
    piiFlag: string;
    piiType: string;
    /** values: N, Y */
    encode: string;
    /** values: N, Y */
    encrypted: string;
    hideEncryptedFlag: boolean;
    maxFlag: string;
    isMaxEditFlag: string;

    /** values: N, Y */
    transpose: string;
    transposeflag: string;
    reference_Key: string;
    selected: string;
    xmlRefKeys: Array<Attribute>;
    /** values: N, Y */
    selectedRefKey: string;
    selectedXmlRefKeys: string;
    /** values: N, Y */
    transposeData: string;
    transposeKey: string;

    masking_Strategy: string;
    strategy_Rule: string;
    repeat_Flag: string;
    partitionType: string;
    bucketRange: string;
    name: any;
    constructor() {
        this.setDefaults();
    }

    setDefaults() {
        this.attr_Id = CommonEnums.defaults.LONG_VAL;
        this.obj_Id = CommonEnums.defaults.LONG_VAL;
        this.attrNm = CommonEnums.defaults.STRING_EMPTY;
        this.attrPrec = CommonEnums.defaults.LONG_VAL;
        this.attrScale = CommonEnums.defaults.NUM_VAL;
        this.attrDTyp_Id = CommonEnums.defaults.NUM_VAL;
        this.attrType_Cd = CommonEnums.defaults.ATTRTYPE_CD;
        this.notNullFlag = CommonEnums.defaults.NUM_VAL;
        this.distKeyFlag = CommonEnums.defaults.NUM_VAL;
        this.attrKeyTyp_Id = CommonEnums.defaults.NUM_VAL;
        this.attrExprVal = CommonEnums.defaults.STRING_EMPTY;
        this.sortType = CommonEnums.defaults.ASC_VAL;
        this.lnk_Attr_Id = CommonEnums.defaults.LONG_VAL;
        this.parent_Attr_Id = CommonEnums.defaults.LONG_VAL;
        this.orgKeyFlag = CommonEnums.defaults.NUM_VAL;
        this.upiFlag = CommonEnums.defaults.NUM_VAL;
        this.usiFlag = CommonEnums.defaults.NUM_VAL;
        this.nupiFlag = CommonEnums.defaults.NUM_VAL;
        this.nusiFlag = CommonEnums.defaults.NUM_VAL;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.valid_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.srt_Order = CommonEnums.defaults.LONG_VAL;
        this.orderBy = CommonEnums.defaults.NUM_VAL;
        this.clevel = CommonEnums.defaults.NUM_VAL;
        this.occurs = 1;
        this.redefines = CommonEnums.defaults.LONG_VAL;

        this.masking_Strategy = CommonEnums.defaults.STRING_EMPTY;
        this.strategy_Rule = CommonEnums.defaults.STRING_EMPTY;
        this.repeat_Flag = CommonEnums.defaults.STRING_EMPTY;
        this.signed = CommonEnums.defaults.STRING_VAL_NO;
        this.tsigned = CommonEnums.defaults.STRING_VAL_NO;
        this.isigned = CommonEnums.defaults.STRING_VAL_NO;
        this.rdeci = CommonEnums.defaults.STRING_VAL_NO;
        this.colformat = CommonEnums.defaults.STRING_EMPTY;
        this.lnk_Obj_Id = CommonEnums.defaults.LONG_VAL;
        this.dependingOn = CommonEnums.defaults.LONG_VAL;
        this.fldFormatValue = CommonEnums.defaults.STRING_EMPTY;
        this.minOccurs = 1;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Obj_Id = CommonEnums.defaults.LONG_VAL;
        this.attrDTypNm = CommonEnums.defaults.STRING_EMPTY;
        this.showAttrPrec = true;
        this.showAttrScale = true;
        this.maxAttrPrec = CommonEnums.defaults.LONG_VAL;
        this.maxAttrScale = CommonEnums.defaults.LONG_VAL;
        this.attrKeyTypLabel = CommonEnums.defaults.STRING_EMPTY;
        this.hideAttrDTyp_Id = false;
        this.hideNotNullFlag = false;
        this.hideAttrKeyTyp_Id = false;
        this.hideDistKeyFlag = false;
        this.hideOrderBy = false;
        this.hideOccurs = false;
        this.hideRedefines = false;
        this.hideMinOcuurs = false;
        this.hideDependingOn = false;
        this.hideSigned = false;
        this.hideTsigned = false;
        this.hideIsigned = false;
        this.hideRdeci = false;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.fldValue = CommonEnums.defaults.STRING_EMPTY;
        this.explodeFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.showExplodeFlg = false;
        this.srcColNm = CommonEnums.defaults.STRING_EMPTY;
        this.srcDTypNm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.repeatedFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.hideRepeatedFlag = false;
        this.minAttrPrec = CommonEnums.defaults.LONG_VAL;
        this.ref_parent_Attr_Id = CommonEnums.defaults.LONG_VAL;
        this.isEditable = CommonEnums.defaults.UNLOCK_IND_UNSET;
        this.hideFldFormatValue = false;
        this.cdcFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.partitionflag = CommonEnums.defaults.DEFAULT_BOOLEAN_VAL;
        this.clusterFlag = CommonEnums.defaults.DEFAULT_BOOLEAN_VAL;
        this.sortBy = CommonEnums.defaults.DEFAULT_BOOLEAN_VAL;
        this.timestampSpec = CommonEnums.defaults.STRING_VAL_NO;
        this.metricsSpec = CommonEnums.defaults.STRING_VAL_NO;
        this.metricsType = 'count';
        this.hiddenFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.identityFlag = CommonEnums.defaults.DEFAULT_BOOLEAN_VAL;
        this.showUnderline = true;
        this.dist_FieldSize = CommonEnums.defaults.DEFAULT_BOOLEAN_VAL;
        this.dist_FieldOffset = CommonEnums.defaults.DEFAULT_BOOLEAN_VAL;
        this.saved_Column = CommonEnums.defaults.DEFAULT_BOOLEAN_VAL;
        this.report_Perspective = CommonEnums.defaults.DEFAULT_ORGANIZAION_NAME;
        this.category = CommonEnums.defaults.STRING_EMPTY;
        this.piiFlag = 'NA';
        this.piiType = CommonEnums.defaults.STRING_EMPTY;
        this.encode = CommonEnums.defaults.STRING_VAL_NO;
        this.encrypted = CommonEnums.defaults.STRING_VAL_NO;
        this.hideEncryptedFlag = false;
        this.maxFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.isMaxEditFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.transpose = CommonEnums.defaults.STRING_VAL_NO;
        this.transposeflag = CommonEnums.defaults.STRING_VAL_NO;
        this.reference_Key = CommonEnums.defaults.STRING_VAL_NO;
        this.selected = CommonEnums.defaults.STRING_VAL_NO;
        this.xmlRefKeys = Array<Attribute>();
        this.selectedRefKey = CommonEnums.defaults.STRING_VAL_NO;
        this.selectedXmlRefKeys = CommonEnums.defaults.STRING_VAL_NO;
        this.transposeData = CommonEnums.defaults.STRING_VAL_NO;
        this.transposeKey = CommonEnums.defaults.STRING_VAL_NO;
        this.partitionType = CommonEnums.defaults.STRING_EMPTY;
        this.bucketRange = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(attributeTmp: Attribute): Attribute {
        let attribute: Attribute = new Attribute();
        attribute.copyFrom(attributeTmp);
        return attribute;
    }

    getPrimaryKey(): string {
        return this.attr_Id + '.' + this.obj_Id + '.' + this.dxMp_Id;
    }

    copy(): Attribute {
        let attributeTmp: Attribute = new Attribute();

        attributeTmp.attr_Id = this.attr_Id;
        attributeTmp.obj_Id = this.obj_Id;
        attributeTmp.attrNm = this.attrNm;

        attributeTmp.masking_Strategy = this.masking_Strategy;
        attributeTmp.strategy_Rule = this.strategy_Rule;
        attributeTmp.repeat_Flag = this.repeat_Flag;

        attributeTmp.attrPrec = this.attrPrec;
        attributeTmp.sortType = this.sortType;
        attributeTmp.attrScale = this.attrScale;
        attributeTmp.attrDTyp_Id = this.attrDTyp_Id;
        attributeTmp.attrType_Cd = this.attrType_Cd;
        attributeTmp.notNullFlag = this.notNullFlag;
        attributeTmp.distKeyFlag = this.distKeyFlag;
        attributeTmp.lnk_Attr_Id = this.lnk_Attr_Id;
        attributeTmp.orgKeyFlag = this.orgKeyFlag;
        attributeTmp.upiFlag = this.upiFlag;
        attributeTmp.usiFlag = this.usiFlag;
        attributeTmp.nupiFlag = this.nupiFlag;
        attributeTmp.clevel = this.clevel;
        attributeTmp.occurs = this.occurs;
        attributeTmp.redefines = this.redefines;
        attributeTmp.signed = this.signed;
        attributeTmp.tsigned = this.tsigned;
        attributeTmp.isigned = this.isigned;
        attributeTmp.rdeci = this.rdeci;
        attributeTmp.colformat = this.colformat;
        attributeTmp.parent_Attr_Id = this.parent_Attr_Id;
        attributeTmp.lnk_Obj_Id = this.lnk_Obj_Id;
        attributeTmp.minOccurs = this.minOccurs;
        attributeTmp.dxMp_Id = this.dxMp_Id;
        attributeTmp.attrDTypNm = this.attrDTypNm;
        attributeTmp.showAttrPrec = this.showAttrPrec;
        attributeTmp.showAttrScale = this.showAttrScale;
        attributeTmp.maxAttrPrec = this.maxAttrPrec;
        attributeTmp.maxAttrScale = this.maxAttrScale;
        attributeTmp.attrKeyTypLabel = this.attrKeyTypLabel;
        attributeTmp.hideAttrDTyp_Id = this.hideAttrDTyp_Id;
        attributeTmp.hideNotNullFlag = this.hideNotNullFlag;
        attributeTmp.hideAttrKeyTyp_Id = this.hideAttrKeyTyp_Id;
        attributeTmp.hideDistKeyFlag = this.hideDistKeyFlag;
        attributeTmp.hideOrderBy = this.hideOrderBy;
        attributeTmp.hideOccurs = this.hideOccurs;
        attributeTmp.hideRedefines = this.hideRedefines;
        attributeTmp.hideMinOcuurs = this.hideMinOcuurs;
        attributeTmp.hideDependingOn = this.hideDependingOn;
        attributeTmp.hideSigned = this.hideSigned;
        attributeTmp.hideTsigned = this.hideTsigned;
        attributeTmp.hideIsigned = this.hideIsigned;
        attributeTmp.hideRdeci = this.hideRdeci;
        attributeTmp.error_Msg = this.error_Msg;
        attributeTmp.fldValue = this.fldValue;
        attributeTmp.explodeFlag = this.explodeFlag;
        attributeTmp.showExplodeFlg = this.showExplodeFlg
        attributeTmp.srcColNm = this.srcColNm;
        attributeTmp.srcDTypNm = this.srcDTypNm;
        attributeTmp.description = this.description;
        attributeTmp.repeatedFlag = this.repeatedFlag;
        attributeTmp.hideRepeatedFlag = this.hideRepeatedFlag;
        attributeTmp.isEditable = this.isEditable;
        attributeTmp.cdcFlag = this.cdcFlag;
        attributeTmp.partitionflag = this.partitionflag;
        attributeTmp.clusterFlag = this.clusterFlag;
        attributeTmp.sortBy = this.sortBy;
        attributeTmp.timestampSpec = this.timestampSpec;
        attributeTmp.metricsSpec = this.metricsSpec;
        attributeTmp.metricsType = this.metricsType;
        attributeTmp.hiddenFlg = this.hiddenFlg;
        attributeTmp.identityFlag = this.identityFlag;
        attributeTmp.showUnderline = this.showUnderline;
        attributeTmp.dist_FieldSize = this.dist_FieldSize;
        attributeTmp.dist_FieldOffset = this.dist_FieldOffset;
        attributeTmp.saved_Column = this.saved_Column;
        attributeTmp.report_Perspective = this.report_Perspective;
        attributeTmp.category = this.category;
        attributeTmp.piiFlag = this.piiFlag;
        attributeTmp.piiType = this.piiType;
        attributeTmp.encode = this.encode;
        attributeTmp.encrypted = this.encrypted;
        attributeTmp.hideEncryptedFlag = this.hideEncryptedFlag;

        //
        attributeTmp.attrKeyTyp_Id = this.attrKeyTyp_Id;
        attributeTmp.attrExprVal = this.attrExprVal;

        attributeTmp.nusiFlag = this.nusiFlag;
        attributeTmp.valid_Cd = this.valid_Cd;
        attributeTmp.srt_Order = this.srt_Order;
        attributeTmp.orderBy = this.orderBy;

        attributeTmp.dependingOn = this.dependingOn;
        attributeTmp.fldFormatValue = this.fldFormatValue;

        attributeTmp.ref_Id = this.ref_Id;
        attributeTmp.ref_Obj_Id = this.ref_Obj_Id;
        attributeTmp.ref_parent_Attr_Id = this.ref_parent_Attr_Id;
        attributeTmp.ref_Cd = this.ref_Cd;

        attributeTmp.minAttrPrec = this.minAttrPrec;
        attributeTmp.minAttrScale = this.minAttrScale;

        attributeTmp.hideFldFormatValue = this.hideFldFormatValue;
        attributeTmp.maxFlag = this.maxFlag;

        attributeTmp.isMaxEditFlag = this.isMaxEditFlag;
        attributeTmp.transpose = this.transpose;
        attributeTmp.transposeflag = this.transposeflag;
        attributeTmp.reference_Key = this.reference_Key;
        attributeTmp.selected = this.selected;
        attributeTmp.xmlRefKeys = AttributesUtil.getInstance().copy(this.xmlRefKeys);
        attributeTmp.selectedRefKey = this.selectedRefKey;
        attributeTmp.selectedXmlRefKeys = this.selectedXmlRefKeys;
        attributeTmp.transposeData = this.transposeData;
        attributeTmp.transposeKey = this.transposeKey;
        attributeTmp.partitionType = this.partitionType;
        attributeTmp.bucketRange = this.bucketRange;
        return attributeTmp;
    }

    copyFrom(attributeTmp: Attribute): void {
        this.attr_Id = attributeTmp.attr_Id;
        this.obj_Id = attributeTmp.obj_Id;
        this.attrNm = attributeTmp.attrNm;

        this.masking_Strategy = attributeTmp.masking_Strategy;
        this.strategy_Rule = attributeTmp.strategy_Rule;
        this.repeat_Flag = attributeTmp.repeat_Flag;

        this.attrPrec = attributeTmp.attrPrec;
        this.sortType = attributeTmp.sortType;
        this.attrScale = attributeTmp.attrScale;
        this.attrDTyp_Id = attributeTmp.attrDTyp_Id;
        this.attrType_Cd = attributeTmp.attrType_Cd;
        this.notNullFlag = attributeTmp.notNullFlag;
        this.distKeyFlag = attributeTmp.distKeyFlag;
        this.lnk_Attr_Id = attributeTmp.lnk_Attr_Id;
        this.orgKeyFlag = attributeTmp.orgKeyFlag;
        this.upiFlag = attributeTmp.upiFlag;
        this.usiFlag = attributeTmp.usiFlag;
        this.nupiFlag = attributeTmp.nupiFlag;
        this.clevel = attributeTmp.clevel;
        this.occurs = attributeTmp.occurs;
        this.redefines = attributeTmp.redefines;
        this.signed = attributeTmp.signed;
        this.tsigned = attributeTmp.tsigned;
        this.isigned = attributeTmp.isigned;
        this.rdeci = attributeTmp.rdeci;
        this.colformat = attributeTmp.colformat;
        this.lnk_Obj_Id = attributeTmp.lnk_Obj_Id;
        this.minOccurs = attributeTmp.minOccurs;
        this.dxMp_Id = attributeTmp.dxMp_Id;
        this.attrDTypNm = attributeTmp.attrDTypNm;
        this.showAttrPrec = attributeTmp.showAttrPrec;
        this.showAttrScale = attributeTmp.showAttrScale;
        this.maxAttrPrec = attributeTmp.maxAttrPrec;
        this.maxAttrScale = attributeTmp.maxAttrScale;
        this.attrKeyTypLabel = attributeTmp.attrKeyTypLabel;
        this.hideAttrDTyp_Id = attributeTmp.hideAttrDTyp_Id
        this.hideNotNullFlag = attributeTmp.hideNotNullFlag;
        this.hideAttrKeyTyp_Id = attributeTmp.hideAttrKeyTyp_Id;
        this.hideDistKeyFlag = attributeTmp.hideDistKeyFlag;
        this.hideOrderBy = attributeTmp.hideOrderBy;
        this.hideOccurs = attributeTmp.hideOccurs;
        this.hideRedefines = attributeTmp.hideRedefines;
        this.hideMinOcuurs = attributeTmp.hideMinOcuurs;
        this.hideDependingOn = attributeTmp.hideDependingOn;
        this.hideSigned = attributeTmp.hideSigned;
        this.hideTsigned = attributeTmp.hideTsigned;
        this.hideIsigned = attributeTmp.hideIsigned;
        this.hideRdeci = attributeTmp.hideRdeci;
        this.error_Msg = attributeTmp.error_Msg;
        this.fldValue = attributeTmp.fldValue;
        this.explodeFlag = attributeTmp.explodeFlag;
        this.showExplodeFlg = attributeTmp.showExplodeFlg;
        this.srcColNm = attributeTmp.srcColNm;
        this.srcDTypNm = attributeTmp.srcDTypNm;
        this.description = attributeTmp.description;
        this.repeatedFlag = attributeTmp.repeatedFlag;
        this.hideRepeatedFlag = attributeTmp.hideRepeatedFlag;
        this.isEditable = attributeTmp.isEditable;
        this.cdcFlag = attributeTmp.cdcFlag;
        this.partitionflag = attributeTmp.partitionflag;
        this.clusterFlag = attributeTmp.clusterFlag;
        this.sortBy = attributeTmp.sortBy;
        this.timestampSpec = attributeTmp.timestampSpec;
        this.metricsSpec = attributeTmp.metricsSpec;
        this.metricsType = attributeTmp.metricsType;
        this.hiddenFlg = attributeTmp.hiddenFlg;
        this.identityFlag = attributeTmp.identityFlag;
        this.showUnderline = attributeTmp.showUnderline;
        this.dist_FieldSize = attributeTmp.dist_FieldSize;
        this.dist_FieldOffset = attributeTmp.dist_FieldOffset;
        this.saved_Column = attributeTmp.saved_Column;
        this.report_Perspective = attributeTmp.report_Perspective;
        this.category = attributeTmp.category;
        this.piiFlag = attributeTmp.piiFlag;
        this.piiType = attributeTmp.piiType;
        this.encode = attributeTmp.encode;
        this.encrypted = attributeTmp.encrypted;
        this.hideEncryptedFlag = attributeTmp.hideEncryptedFlag;

        //
        this.attrKeyTyp_Id = attributeTmp.attrKeyTyp_Id;
        this.attrExprVal = attributeTmp.attrExprVal;

        this.parent_Attr_Id = attributeTmp.parent_Attr_Id;

        this.nusiFlag = attributeTmp.nusiFlag;
        this.valid_Cd = attributeTmp.valid_Cd;
        this.srt_Order = attributeTmp.srt_Order;
        this.orderBy = attributeTmp.orderBy;

        this.dependingOn = attributeTmp.dependingOn;
        this.fldFormatValue = attributeTmp.fldFormatValue;

        this.ref_Id = attributeTmp.ref_Id;
        this.ref_Obj_Id = attributeTmp.ref_Obj_Id;
        this.ref_parent_Attr_Id = attributeTmp.ref_parent_Attr_Id;
        this.ref_Cd = attributeTmp.ref_Cd;

        this.minAttrPrec = attributeTmp.minAttrPrec;
        this.minAttrScale = attributeTmp.minAttrScale;

        this.hideFldFormatValue = attributeTmp.hideFldFormatValue;
        this.maxFlag = attributeTmp.maxFlag;

        this.isMaxEditFlag = attributeTmp.isMaxEditFlag;
        this.transpose = attributeTmp.transpose;
        this.transposeflag = attributeTmp.transposeflag;
        this.reference_Key = attributeTmp.reference_Key;
        this.selected = attributeTmp.selected;
        AttributesUtil.getInstance().copyFrom(this.xmlRefKeys, attributeTmp.xmlRefKeys);
        this.selectedRefKey = attributeTmp.selectedRefKey;
        this.selectedXmlRefKeys = attributeTmp.selectedXmlRefKeys;
        this.transposeData = attributeTmp.transposeData;
        this.transposeKey = attributeTmp.transposeKey;
        this.partitionType = attributeTmp.partitionType;
        this.bucketRange = attributeTmp.bucketRange;
    }

    compare(attributeTmp: Attribute): string {
        let attributeString: string = this.toString(false);
        let attributeTmpString: string = attributeTmp.toString(false);

        if (attributeString != attributeTmpString) {
            return attributeString + ',' + attributeTmpString;
        }

        return CommonEnums.defaults.STRING_EMPTY;
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Attribute [attr_Id=" + this.attr_Id + ", obj_Id=" + this.obj_Id +
            ", attrNm=" + this.attrNm + ", attrPrec=" + this.attrPrec +
            ", masking_Strategy=" + this.masking_Strategy + ", strategy_Rule=" + this.strategy_Rule + ", repeat_Flag=" + this.repeat_Flag +
            ", attrScale=" + this.attrScale + ", attrDTyp_Id=" + this.attrDTyp_Id + ", attrType_Cd=" + this.attrType_Cd +
            ", notNullFlag=" + this.notNullFlag + ", distKeyFlag=" + this.distKeyFlag +
            ", attrKeyTyp_Id=" + this.attrKeyTyp_Id + ", attrExprVal=" + this.attrExprVal + ", lnk_Attr_Id=" + this.lnk_Attr_Id +
            ", parent_Attr_Id=" + this.parent_Attr_Id + ", orgKeyFlag=" + this.orgKeyFlag +
            ", upiFlag=" + this.upiFlag + ", usiFlag=" + this.usiFlag + ", nupiFlag=" + this.nupiFlag +
            ", nusiFlag=" + this.nusiFlag + ", valid_Cd=" + this.valid_Cd +
            ", srt_Order=" + this.srt_Order + ", orderBy=" + this.orderBy + ", clevel=" + this.clevel +
            ", occurs=" + this.occurs + ", redefines=" + this.redefines +
            ", signed=" + this.signed + ", tsigned=" + this.tsigned + ", isigned=" + this.isigned +
            ", rdeci=" + this.rdeci + ", colformat=" + this.colformat +
            ", lnk_Obj_Id=" + this.lnk_Obj_Id + ", dependingOn=" + this.dependingOn + ", fldFormatValue=" + this.fldFormatValue +
            ", minOccurs=" + this.minOccurs + ", dxMp_Id=" + this.dxMp_Id +
            ", isEditable=" + this.isEditable + ", fldValue=" + this.fldValue + ", explodeFlag=" + this.explodeFlag +
            ", repeatedFlag=" + this.repeatedFlag + ", cdcFlag=" + this.cdcFlag +
            ", timestampSpec=" + this.timestampSpec + ", metricsSpec=" + this.metricsSpec + ", metricsType=" + this.metricsType +
            ", hiddenFlg=" + this.hiddenFlg + ", identityFlag=" + this.identityFlag +
            ", category=" + this.category +
            + ", description=" + this.description +
            ", partitionflag=" + this.partitionflag + ", clusterFlag=" + this.clusterFlag +
            ", sortBy=" + this.sortBy + ", showUnderline=" + this.showUnderline + ", dist_FieldSize=" + this.dist_FieldSize +
            ", dist_FieldOffset=" + this.dist_FieldOffset + ", saved_Column=" + this.saved_Column + + ", piiType=" + this.piiType +
            ", report_Perspective=" + this.report_Perspective + ", piiFlag=" + this.piiFlag + ", encode=" + this.encode +
            ", encrypted=" + this.encrypted + ", maxFlag=" + this.maxFlag +
            ", transpose=" + this.transpose +
            ", transposeflag=" + this.transposeflag + ", reference_Key=" + this.reference_Key +
            ", selectedXmlRefKeys=" + this.selectedXmlRefKeys + ", sortType=" + this.sortType +
            ", transposeData=" + this.transposeData + ", transposeKey= " + this.transposeKey +
            ", partitionType=" + this.partitionType + ", bucketRange= " + this.bucketRange;

        if (isNotCompare) {
            str += ", srcColNm=" + this.srcColNm +
                ", srcDTypNm=" + this.srcDTypNm + ", ref_Id=" + this.ref_Id + ", ref_Obj_Id=" + this.ref_Obj_Id +
                ", ref_parent_Attr_Id=" + this.ref_parent_Attr_Id + ", ref_Cd=" + this.ref_Cd +
                ", attrDTypNm=" + this.attrDTypNm + ", showAttrPrec=" + this.showAttrPrec + ", showAttrScale=" + this.showAttrScale +
                ", maxAttrPrec=" + this.maxAttrPrec + ", maxAttrScale=" + this.maxAttrScale +
                ", attrKeyTypLabel=" + this.attrKeyTypLabel + ", hideAttrDTyp_Id=" + this.hideAttrDTyp_Id + ", hideNotNullFlag=" + this.hideNotNullFlag +
                ", hideAttrKeyTyp_Id=" + this.hideAttrKeyTyp_Id + ", hideDistKeyFlag=" + this.hideDistKeyFlag +
                ", hideOrderBy=" + this.hideOrderBy + ", hideOccurs=" + this.hideOccurs + ", hideRedefines=" + this.hideRedefines +
                ", hideMinOcuurs=" + this.hideMinOcuurs + ", hideDependingOn=" + this.hideDependingOn +
                ", hideSigned=" + this.hideSigned + ", hideTsigned=" + this.hideTsigned + ", hideIsigned=" + this.hideIsigned +
                ", hideRdeci=" + this.hideRdeci + ", error_Msg=" + this.error_Msg + ",isMaxEditFlag=" + this.isMaxEditFlag +
                ", hideRepeatedFlag=" + this.hideRepeatedFlag + ", minAttrPrec=" + this.minAttrPrec + ", minAttrScale=" + this.minAttrScale +
                ", showExplodeFlg=" + this.showExplodeFlg + ", hideFldFormatValue=" + this.hideFldFormatValue +
                ", hideEncryptedFlag=" + this.hideEncryptedFlag + ", selected=" + this.selected +
                ", xmlRefKeys=" + this.xmlRefKeys + ", selectedRefKey=" + this.selectedRefKey +
                ", transposeData=" + this.transposeData + ", transposeKey=" + this.transposeKey;
        }

        str += ']';

        return str;
    }
}